// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"064be305","453":"2be7b963","732":"d19b9e68","977":"ea231df3"}[chunkId] + ".chunk.js";
};